module.exports = __webpack_public_path__ + "img/HausMitRädern.dbe31398.jpg";